// Filter Interfaces - Teams and Pests
// https://lunrjs.com/  (or maybe http://elasticlunr.com/)
// https://lunrjs.com/guides/getting_started.html

import * as $ from 'jquery';
import Debouncer from './Debouncer';

import * as lunr from 'lunr';
import replaceStemerWithOneThatKeepsOriginalAndStems from '../lib/lunr/replaceStemerWithOneThatKeepsOriginalAndStems';

const documents: Array<any> = [];
const columnNames: Array<string> = [];
let idx: lunr.Index;

const $table = $('table.products-table');
if($table.length) {
	// Documents to be indexed. Look for elements with @data-obj attribute and grabs json from @data-obj
	$table.find('thead > tr > th').each((columnIndex, th) => {
		columnNames[columnIndex] = $(th).find('[data-search-field]').attr('data-search-field');
	});

	// get the product table filters - we removed these from the table for mobile design purposes
	const $tableFilters = $('.products-table__filters');
	$tableFilters.find('.products-table__filterItem').each((columnIndex, item) => {
		columnNames[columnIndex] = $(item).find('[data-search-field]').attr('data-search-field');
	});

	// Get all data from table
	const $objs = $table.find('tbody > tr');
	$objs.each((index, element) => {
		const doc: any = {};

		$(element).find('td').each((columnIndex, td) => {
			const name = columnNames[columnIndex];
			// if no column name stop? 
			if (!name) {
				return;
			}

			let value;
			// if multiple elements, get specific elem data by class
			const valueFrom = $(td).find('.product-row__set-value');
			if (valueFrom.length > 0) {
				value = valueFrom.text();
			} else {
				value = td.textContent;
			}
			value = value.trim();
			if (value.match(/^[^\s]+\-[^\s]+$/)) {
				// Hack to get SW-AW1236 to be indexed as "SW-AW1236 SWAW1236"
				//   without doing this you SWAW1236 (w/o hyphen) will not match
				doc[name] = value + ' ' + value.replace(/\-+/, '');
			} else {
				doc[name] = value;
			}
		});
		doc.id = element.getAttribute('data-obj-id');
		doc.objType = element.getAttribute('data-obj');
		doc.domElement = element;

		documents.push(doc);
	});

	// Create searchable index of documents
	idx = lunr(function () {
		this.use(replaceStemerWithOneThatKeepsOriginalAndStems);

		const refName = 'id';

		this.ref(refName);	// 'id' is default

		documents.forEach((doc) => {

			// Must inform of fields before indexing
			for (const propName in doc) {
				if (!(this._fields as any)[propName]) {
					this.field(propName);
				}
			}

			// Add document
			this.add(doc);
		} );
	});

	// Search index
	const $searches = $('[data-search-obj]');

	// When a value changes
	const updateResults = (event: JQuery.TriggeredEvent) => {
		// Find search container
		const $searchContainer = $(event.target).closest('[data-search-obj]');
		updateSearchResults($searchContainer);

		event.preventDefault();
	};
	$searches.on('change submit', updateResults);
	$searches.on('keyup', new Debouncer(updateResults, false, 1000).run);

	// When user clicks back in history
	window.onpopstate = function(event: Event) {
		if(event) {
			updateFormBasedOnURL();
		}
	};

	init();
}

function updateSearchResults($searchContainer: JQuery, updateHistory: boolean = true) {
	// Construct query
	// https://lunrjs.com/guides/searching.html
	let query = '';

	// Determine object type we are searching
	const objType = $searchContainer.attr('data-search-obj');
	query += '+objType:' + objType;

	// get query params from url
	const params = new URLSearchParams();

	// Add value from form input fields to query
	const $fields = $searchContainer.find('[data-search-field]');

	$fields.each((index, element) => {
		const input = element as HTMLInputElement;
		let inputName = input.getAttribute('data-search-field');

		// const inputName = input.getAttribute('name');
		const field = input.getAttribute('data-search-field');
		// const type = input.getAttribute('type') ?? 'select';
		let value: string = input.value;

		// Add to params for pushState
		if (inputName && value.length > 0) {
			params.append(inputName, value);
		}

		// Clean value so it is safe for use in queries
		value = value.replace(/[^\sA-Za-z_\-0-9]+/g, '');                

		// Add value to query
		if (value.length > 0) {
			value.split(/[\s\-]+/).forEach((value) => {
				if (value.length > 0) {
					// TODO: do not add '*' to all
					query += ' +' + field + ':' + value + '*';
				}
			});
		}
	});

	// console.log('Searching for:', query);

	if (updateHistory) {
		// State - Update location bar
		let url = $searchContainer.attr('action').toLowerCase().replace(/\s/g , "-");
		const paramAsString = params.toString();

		if (paramAsString) {
			url += '?' + paramAsString;
		}
		history.pushState({}, '', url);
	}

	// Lunr - Conduct search
	const matches: Array<lunr.Index.Result> = idx.search(query);
	const matchIds = matches.map(result => result.ref);

	// if no matches show 'no results' message
	if(!matches.length) {
		document.querySelector('.productResultsLayout__noResults').classList.add('show');
	} else {
		document.querySelector('.productResultsLayout__noResults').classList.remove('show');
	}

	documents.forEach((doc) => {
		if (doc.objType === objType) {
			// One that we are dealing with
			if (matchIds.indexOf(doc.id) >= 0) {
				// console.log('match', doc.id, doc);
				doc.domElement.setAttribute('search-match', 'true');
			} else {
				// console.log('not a match', doc.id, matchIds.indexOf(doc.id));
				doc.domElement.setAttribute('search-match', 'false');
			}
		}
	});
}


function updateFormBasedOnURL() {
	const queryString = window.location.search;
	const params = new URLSearchParams(queryString);
	const $form = $('form[data-search-obj]');

	// Update form fields.
	$form.find('[data-search-field]').each((index, input: HTMLInputElement) => {
		if(params.get(input.getAttribute('data-search-field'))) {
			input.value = params.get(input.getAttribute('data-search-field'));
		}
	});

	// Update results
	updateSearchResults($form, false);
};

function convertFractionToNumber(value: string) {
	value = value.replace(/"/g, '');
	value = value.replace(/ +/g, '+');
	if (value.match(/^[0-9\+\/]+$/)) {
		return eval(value);
	}
	return false;
}
function init() {
	// Add existing data to form fields
	columnNames.forEach((col, index) => {
		let colSelector = '#product-' + col;
		let formElement = $(colSelector);
		if (!formElement.is('select')) {
			return;
		}

		documents.map(item => item[col])
			.filter((value, index, self) => self.indexOf(value) === index)
			.map(item => {
				const opt = document.createElement('option');
				opt.value = item;
				opt.text = item;
				return opt;
			})
			.sort((a, b) => {
				const aN = convertFractionToNumber(a.value);
				const bN = convertFractionToNumber(b.value);
				if (aN !== false && bN !== false) {
					// TODO: convert fractions
					return aN - bN;
				}
				if (a && a.value !== null && a.value != undefined) {
					return a.value.localeCompare(b.value);
				}
				return 0;
			})
			.forEach((opt) => {
				(formElement.get(0) as HTMLSelectElement).add(opt);
			});
	});

	updateFormBasedOnURL();
}